import { gql } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getStatus, getStatusIcon } from '../helpers';

export const classLinkRecentDistrictSyncJobsQuery = gql`
    query classLinkRecentDistrictSyncJobs($districtId: String!, $numResults: Int!) {
        classLinkRecentDistrictSyncJobs(districtId: $districtId, numResults: $numResults) {
            id
            initiatedBy
            status
            createdAt
            wasScheduledJob
            __typename
        }
    }
`;

const MessageWrap = styled.p`
    img {
        float: left;
        margin-top: 5px;
    }
`;

const ClassLinkSyncPanel = ({ districtId }) => (
    <Query
        query={classLinkRecentDistrictSyncJobsQuery}
        variables={{
            districtId,
            numResults: 1,
        }}
    >
        {({ data, startPolling, stopPolling, loading }) => {
            if (!data || loading) {
                return null;
            }
            const { classLinkRecentDistrictSyncJobs } = data;

            const areAnySyncsProcessing = (classLinkRecentDistrictSyncJobs || []).some(
                sync => sync.status === 'processing' || sync.status === 'pending',
            );

            // Refreshing sync list every 30sec if any job is in processing state
            if (areAnySyncsProcessing) {
                startPolling(30000);
            } else {
                stopPolling();
            }
            const hasSyncJobs = classLinkRecentDistrictSyncJobs && classLinkRecentDistrictSyncJobs.length > 0;

            return hasSyncJobs ? (
                <MessageWrap data-testid="message-wrap">
                    {getStatusIcon(classLinkRecentDistrictSyncJobs[0].status)}
                    {`Latest sync status is ${getStatus(classLinkRecentDistrictSyncJobs[0].status)}`}
                </MessageWrap>
            ) : (
                ''
            );
        }}
    </Query>
);

ClassLinkSyncPanel.propTypes = {
    districtId: PropTypes.string.isRequired,
};

export default ClassLinkSyncPanel;
